import axios from 'axios'; 

export let axiosClone=axios.create({
    headers:{
        AccessControlAllowOrigin: '*'
    }
})